export default __webpack_public_path__ + "static/Poppins-Bold.cdb29a5d.ttf";